(function () {
  'use strict';

  if (window.slMonogramCartSyncLoaded) return;
  window.slMonogramCartSyncLoaded = true;

  function initialize() {
    var form = document.getElementById('cart_form');
    if (!form || form.dataset.slFeeSync === 'true') return;

    var feeVariantId = 39542740549697;
    var busy = false;

    var routeRoot =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    function rows() {
      return Array.from(
        form.querySelectorAll('[data-cart-item][data-sl-cart-key]')
      );
    }

    function quantityInput(row) {
      return row.querySelector('input[name="updates[]"]');
    }

    var message = document.createElement('p');
    message.setAttribute('role', 'alert');
    message.hidden = true;
    message.style.color = '#b00020';
    message.style.margin = '15px 0';
    form.prepend(message);

    function showError(text) {
      message.textContent = text;
      message.hidden = false;
      message.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    function collectDesiredQuantities() {
      var desired = {};

      rows().forEach(function (row) {
        if (row.dataset.slMonogramFee === 'true') return;

        var input = quantityInput(row);
        if (!input) {
          throw new Error('A cart quantity field could not be found.');
        }

        var quantity = Number(input.value);

        if (!Number.isSafeInteger(quantity) || quantity < 0) {
          throw new Error('Enter a whole-number quantity of zero or more.');
        }

        desired[row.dataset.slCartKey] = quantity;
      });

      return desired;
    }

    function cartDetails() {
      var data = new FormData(form);
      var details = {};

      if (data.has('note')) {
        details.note = String(data.get('note') || '');
      }

      var attributes = {};

      data.forEach(function (value, key) {
        var match = key.match(/^attributes\[(.+)\]$/);

        if (match && typeof value === 'string') {
          attributes[match[1]] = value;
        }
      });

      if (Object.keys(attributes).length) {
        details.attributes = attributes;
      }

      return details;
    }

    async function request(path, payload) {
      var options = {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      };

      if (payload !== undefined) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }

      var response = await fetch(routeRoot + path, options);
      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'The cart could not be updated.'
        );
      }

      return result;
    }

    function isFee(item) {
      return Number(item.variant_id) === feeVariantId;
    }

    function hasMonogram(item) {
      var value = item.properties && item.properties.Monogram;
      return typeof value === 'string' && value.trim() !== '';
    }

    function requiredFeeQuantity(cart) {
      return cart.items.reduce(function (total, item) {
        return total + (
          !isFee(item) && hasMonogram(item) ? item.quantity : 0
        );
      }, 0);
    }

    function setBusy(value) {
      busy = value;

      if (value) {
        form.setAttribute('aria-busy', 'true');
        form.setAttribute('inert', '');
      } else {
        form.removeAttribute('aria-busy');
        form.removeAttribute('inert');
      }
    }

    async function synchronize(goToCheckout) {
      if (busy) return;

      message.hidden = true;

      var desired;
      var details;

      try {
        desired = collectDesiredQuantities();
        details = cartDetails();
      } catch (error) {
        showError(error.message);
        return;
      }

      setBusy(true);

      try {
        var current = await request('cart.js');
        var currentKeys = new Set(
          current.items.map(function (item) {
            return item.key;
          })
        );

        // Do not update stale line identifiers.
        Object.keys(desired).forEach(function (key) {
          if (!currentKeys.has(key)) {
            throw new Error(
              'Your cart changed in another session. Reload before editing it.'
            );
          }
        });

        var updates = { ...desired };
        var desiredFeeQuantity = 0;

        current.items.forEach(function (item) {
          if (isFee(item) || !hasMonogram(item)) return;

          var quantity = Object.prototype.hasOwnProperty.call(
            desired,
            item.key
          ) ? desired[item.key] : item.quantity;

          desiredFeeQuantity += quantity;
        });

        var feeItems = current.items.filter(isFee);

        // Consolidate any existing fee lines into one.
        feeItems.forEach(function (item, index) {
          updates[item.key] = index === 0 ? desiredFeeQuantity : 0;
        });

        var updated = await request('cart/update.js', {
          ...details,
          updates: updates
        });

        // Use the returned cart to confirm the required fee quantity.
        var needed = requiredFeeQuantity(updated);
        var returnedFees = updated.items.filter(isFee);

        if (!returnedFees.length && needed > 0) {
          await request('cart/add.js', {
            items: [{
              id: feeVariantId,
              quantity: needed
            }]
          });
        } else if (returnedFees.length) {
          var correction = {};
          var correctionNeeded = false;

          returnedFees.forEach(function (item, index) {
            var target = index === 0 ? needed : 0;
            correction[item.key] = target;

            if (item.quantity !== target) {
              correctionNeeded = true;
            }
          });

          if (correctionNeeded) {
            await request('cart/update.js', {
              updates: correction
            });
          }
        }

        var confirmed = await request('cart.js');
        var expected = requiredFeeQuantity(confirmed);

        var actual = confirmed.items.reduce(function (total, item) {
          return total + (isFee(item) ? item.quantity : 0);
        }, 0);

        if (actual !== expected) {
          throw new Error('The monogram fee quantity could not be confirmed.');
        }

        window.location.assign(
          routeRoot + (goToCheckout ? 'checkout' : 'cart')
        );
      } catch (error) {
        setBusy(false);

        showError(
          (error.message || 'The cart update could not be confirmed.') +
          ' Check or reload your cart before trying again.'
        );
      }
    }

    function handleQuantityButton(event, button) {
      var row = button.closest('[data-cart-item]');
      if (!row || !form.contains(row)) return;

      var input = quantityInput(row);
      if (!input) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (busy) return;

      if (row.dataset.slMonogramFee !== 'true') {
        var quantity = Number(input.value);

        if (!Number.isSafeInteger(quantity) || quantity < 0) {
          showError('Enter a valid quantity before using the quantity controls.');
          return;
        }

        var change = button.dataset.func === 'plus' ? 1 : -1;
        input.value = Math.max(0, quantity + change);
      }

      synchronize(false);
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var remove = event.target.closest('[data-remove-item]');

      if (remove && form.contains(remove)) {
        var row = remove.closest('[data-cart-item]');
        if (!row) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (busy) return;

        var input = quantityInput(row);

        if (!input) {
          showError('The quantity field for this item could not be found.');
          return;
        }

        if (row.dataset.slMonogramFee !== 'true') {
          input.value = 0;
        }

        synchronize(false);
        return;
      }

      var quantityButton = event.target.closest(
        '.js-change-quantity[data-func]'
      );

      if (quantityButton && form.contains(quantityButton)) {
        handleQuantityButton(event, quantityButton);
        return;
      }

      var checkoutButton = event.target.closest('[name="checkout"]');

      if (checkoutButton && form.contains(checkoutButton)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        synchronize(true);
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (
        !(event.target instanceof Element) ||
        !form.contains(event.target) ||
        !event.target.matches('input[name="updates[]"]')
      ) {
        return;
      }

      event.stopImmediatePropagation();
      synchronize(false);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitter = event.submitter;

      synchronize(
        Boolean(submitter && submitter.name === 'checkout')
      );
    }, true);

    // Cover theme code that submits this form directly.
    form.submit = function () {
      synchronize(false);
    };

    form.dataset.slFeeSync = 'true';
  var initialRows = rows();
var expectedFees = 0;
var displayedFees = 0;

initialRows.forEach(function (row) {
  var input = quantityInput(row);
  if (!input) return;

  var quantity = Number(input.value);

  if (!Number.isSafeInteger(quantity) || quantity < 0) return;

  if (row.dataset.slMonogramFee === 'true') {
    displayedFees += quantity;
  } else if (
    row.dataset.slMonogram &&
    row.dataset.slMonogram.trim() !== ''
  ) {
    expectedFees += quantity;
  }
});

if (displayedFees !== expectedFees) {
  synchronize(false);
}

  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
